import { useContext, useEffect } from "react";
import { useTheme } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";
import { StoreContext } from "../../../store/context";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import TrackingUtil from "../../../utils/tracking";
import { NC_EVT } from "../../../constants/tracking";
import { useThemeStyles } from "../../../styles/themes";
import "./ApplicationSubmittedDowntime.scss";

const { REACT_APP_SUPPORT_EMAIL } = process.env;

// Shown when creditScoring returns error 1001 (Experian down); app received, limit after maintenance ends

const ApplicationSubmittedDowntime = () => {
  const classes = useThemeStyles();
  const theme = useTheme();
  const { state } = useContext(StoreContext);

  useEffect(() => {
    TrackingUtil.sendNetcoreEventHelper(NC_EVT.OUTCOME_REG_FAILED, { source: "main" });
  }, []);

  return (
    state.prerequisites
    && (
      <>
        <Header />
        <div className="page page-application-submitted-downtime">
          <div
            className={`${classes.content} ${classes.customScrollbar} content custom-scrollbar`}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <img
                className="banner"
                src="/images/maintenance@2x.png"
                alt="application-submitted"
              />
              <p className="downtime-title">Application Submitted</p>
              <p className="downtime-sub-title">Your application has been received.</p>
              <p className="downtime-sub-title">
                Due to scheduled maintenance, we are still processing your credit limit. We will notify you via WhatsApp once it is ready, or please check again in 12 hours.
              </p>
              <p className="downtime-sub-title">
                For assistance, please contact our Support Team at{" "}
                <a
                  href={`mailto:${REACT_APP_SUPPORT_EMAIL}`}
                  style={{ color: theme.palette.primary.main, fontWeight: "bold" }}
                >
                  {REACT_APP_SUPPORT_EMAIL}
                </a>
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </>
    )
  );
};

export default withUbdAnalyticsStep(ApplicationSubmittedDowntime, {
  stepId: "ApplicationSubmittedDowntime",
  endJourneyOnStepStart: true,
});
